export default __webpack_public_path__ + "static/media/2788.11dbf09e.png";